// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1hJjT","unreadBadge":"styles_unreadBadge__1eS2d","modalContent":"styles_modalContent__12tvb","modal":"styles_modal__2nPc3"};